import { combineReducers } from 'redux-immer'
import { connectRouter } from 'connected-react-router'
import produce from 'immer'
import authReducer from './authReducer'
import companyReducer from './companyReducer'
import productMappingReducer from './productMappingReducer'
import approvalReducer from './approvalReducer'
import reconReducer from './reconReducer'
import reportsReducer from './reportsReducer'
import emailReportsReducer from './emailReportsReducer'
import backup365ReportsReducer from './backup365ReportsReducer'
import keeperReconReducer from './keeperReconReducer'
import threatlockerReconReducer from './threatlockerReconReducer'
import cspRenewalsReducer from './cspRenewalsReducer'
import cspLicensesReducer from './cspLicensesReducer'
import sasbossDidReducer from './sasbossDidReducer'

let rootReducer = (history) =>
  combineReducers(produce, {
    auth: authReducer,
    router: connectRouter(history),
    company: companyReducer,
    productMapping: productMappingReducer,
    approval: approvalReducer,
    recon: reconReducer,
    reports: reportsReducer,
    emailReports: emailReportsReducer,
    backup365Reports: backup365ReportsReducer,
    keeperRecon: keeperReconReducer,
    threatlockerRecon: threatlockerReconReducer,
    cspRenewals: cspRenewalsReducer,
    cspLicenses: cspLicensesReducer,
    sasbossDid: sasbossDidReducer,
  })

export default rootReducer
